module.exports = __webpack_public_path__ + "media/assets/artaround-pin-69f6adcb65fb986de3eada42256e0f6a.png";